// extracted by mini-css-extract-plugin
module.exports = {"copyWrap":"CopyRenderer_copyWrap__+OAN6","iconWrap":"CopyRenderer_iconWrap__kwknN","noHover":"CopyRenderer_noHover__BFJi8","iconWrap_active":"CopyRenderer_iconWrap_active__abl3U"};